export function formatHashtag(name: string): string {
  return name.replace(/\s+/g, "").toLowerCase();
}

export const generateTitle = (prefix?: string): string =>
  `${prefix ? `${prefix} · ` : ""}Квиз, плиз! Хоум игры`;
